export const ToasterMessageType = {
    Error: "error",
    Info: "info",
    Success: "success",
    Warning: "warning"
};
